<!-- Tab Headers -->
<div class="w-full overflow-x-auto">
    <div
        class="inline-flex items-center gap-1 rounded-lg border border-slate-200 bg-slate-50 p-1"
    >
        @for (item of tabList; track item; let idx = $index) {
            <button
                type="button"
                class="cursor-pointer whitespace-nowrap rounded-md px-4 py-2 text-sm font-medium transition-all"
                [ngClass]="{
                    'bg-white text-primary-700 shadow-sm': item.isActive,
                    'text-slate-600 hover:text-slate-800': !item.isActive,
                }"
                (click)="selectTab(item)"
            >
                <span class="inline-flex items-center gap-2">
                    <span>{{ item.tabTitle }}</span>
                    @if (item.tabCount !== undefined) {
                        <span
                            class="inline-flex min-w-[1.25rem] items-center justify-center rounded-full bg-slate-100 px-2 py-0.5 text-xs font-medium text-slate-600"
                        >
                            {{ item.tabCount }}
                        </span>
                    }
                </span>
            </button>
        }
    </div>
</div>

<!-- Tab Content -->
<div class="mt-4">
    <ng-content select="app-tab"></ng-content>
</div>
